import { WEB_URL } from "@/config/endpoints";

export function getHTSCodeSchema({ pageMetaTitle,pageUrl,pageMetaDesc,hsnCode,hsnCodeDesc,page }) {
  return {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": pageMetaTitle,
  "url": pageUrl,
  "description": pageMetaDesc,
  "mainEntity": {
    "@type": "DefinedTerm",
    name:
    page.startsWith("hts-code")
      ? `HTS Code ${hsnCode}`
      : `Mexico Import Duty ${hsnCode}`,
    "inDefinedTermSet": WEB_URL+`/${page}`,
    "termCode": hsnCode,
    "description": hsnCodeDesc,
    "identifier":hsnCode
  },
  "publisher": {
    "@type": "Organization",
    "name": "Credlix",
    "url":WEB_URL
  }
}
}
